import styled from 'styled-components'

import { color } from '../../../styles'

export const Wrap = styled.label`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20.8rem;
  height: 20.8rem;
  margin-top: 3.2rem;
  border-radius: 50%;
  background-color: ${color.WHITE};
`

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`

export const EditWrap = styled.div`
  position: absolute;
  bottom: -2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
